import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { XCircle, Home } from 'lucide-react';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <Card className="max-w-md w-full p-10 border border-border shadow-sm text-center">
        <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-red-600" />
        </div>
        <h1 className="text-xl sm:text-2xl md:text-3xl font-medium mb-3" data-testid="payment-cancel-title">Payment Cancelled</h1>
        <p className="text-muted-foreground mb-8">Your payment was cancelled. Your lease will remain active but unpaid.</p>
        <div className="space-y-3">
          <Button data-testid="view-leases-btn" onClick={() => navigate('/leases')}
            className="w-full rounded-full bg-primary hover:bg-primary/90 text-primary-foreground btn-hover">View My Leases</Button>
          <Button data-testid="back-home-btn" onClick={() => navigate('/')} variant="outline" className="w-full rounded-full">
            <Home className="w-4 h-4 mr-2" />Back to Home
          </Button>
        </div>
      </Card>
    </div>
  );
}
